import { useEffect, useRef, useState } from 'react';
import { Block, List, ListItem, Navbar, Page } from 'konsta/react';
import TabBar from '../components/TabBar';
import { useAppContext } from '../context/AppContext';
import { TgUser } from '../models/Models';
import { MdOutlineContentCopy } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import { popup, shareURL } from '@telegram-apps/sdk';
import { mixTrack } from '../helpers/MixPanelHelper';

const ProfilePage = () => {
  const { tgUser } = useAppContext();
  const [refLink, setRefLink] = useState<string>();
  const navigate = useNavigate();

  useEffect(() => {
    if (tgUser) {
      setRefLink(
        `https://t.me/${process.env.REACT_APP_BOT_USERNAME}?start=${tgUser.id}`,
      );
    }
  }, [tgUser]);

  return (
    <Page className=" pb-40">
      {tgUser && (
        <>
          <Block>
            <h1 className="currency text-2xl tracking-widest">
              {tgUser.username}
            </h1>
          </Block>

          <List strong outline>
            <ListItem
              onClick={async () => {
                navigator.clipboard.writeText(refLink ?? '-');
                if (popup.isSupported()) {
                  const promise = popup.open({
                    title: 'Referral Link',
                    message: 'Referral link has been copied to clipboard.',
                    buttons: [{ id: 'ok', type: 'ok' }],
                  });

                  const buttonId = await promise;
                }
              }}
              header="Referral Link"
              title={
                <span className="text-primary text-xs">{refLink ?? ''}</span>
              }
              after={<MdOutlineContentCopy className="text-primary" />}
            />
          </List>

          <List strong outline>
            {shareURL.isAvailable() && refLink && (
              <ListItem
                link
                title="Invite a friend"
                onClick={() => {
                  shareURL(
                    refLink,
                    `Hey! I’m using MYNR to earn passive income every day! 💰 With cloud-based miners, I don’t worry about electricity or maintenance—I just earn. Join me and start mining too! 🚀 Sign up here: ${refLink}`,
                  );
                }}
              />
            )}
            <ListItem
              link
              title="Referrals"
              onClick={() => {
                mixTrack('[View] Referrals');
                navigate('/referrals');
              }}
            />
            <ListItem
              link
              title="Transactions"
              onClick={() => navigate('/transactions')}
            />
            <ListItem
              title="Customer Id"
              after={<span className="text-primary text-lg">{tgUser.id}</span>}
            />
          </List>
        </>
      )}
      <TabBar selectedTab="profile" />
    </Page>
  );
};

export default ProfilePage;
